import { IApiError } from '@/models/apiError.model';

export const isApiErrorEntity = (error: unknown): error is IApiError => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    typeof (error as any).status === 'number' &&
    'message' in error &&
    typeof (error as any).message === 'string' &&
    (!('errors' in error) ||
      (typeof (error as any).errors === 'object' &&
        ((error as any).errors === null || !Array.isArray((error as any).errors))))
  );
};
